import { CLIENT_METHODS, RESOURCES, useApiMutation } from '@/data/api'

export const useValidateEmailInvite = (): ReturnType<typeof useApiMutation> =>
  useApiMutation(RESOURCES.VALIDATE_EMAIL_INVITE, CLIENT_METHODS.PATCH)
